import type { Block, SpacerBlockContent } from '@/types';

interface SpacerBlockProps {
  block: Block;
  isEditable?: boolean;
  onUpdate?: (patch: Partial<Block>) => void;
}

function SpacerBlock({ block, isEditable = false, onUpdate }: SpacerBlockProps) {
  const content = block.content as SpacerBlockContent;
  const height = content.height || 32;

  if (isEditable) {
    return (
      <div>
        <div className="flex gap-4 mb-2 p-2 bg-gray-100 rounded items-center">
          <span className="text-xs text-muted-foreground">Hoogte:</span>
          <input
            type="range"
            min={8}
            max={120}
            step={8}
            value={height}
            onChange={(e) => {
              onUpdate?.({ content: { ...content, height: Number(e.target.value) } });
            }}
            className="w-[150px] accent-primary"
          />
          <span className="text-xs font-medium">{height}px</span>
        </div>

        <div
          className="flex items-center justify-center bg-gray-50 border border-dashed border-gray-300 rounded"
          style={{ height }}
        >
          <span className="text-xs text-muted-foreground">Ruimte: {height}px</span>
        </div>
      </div>
    );
  }

  return <div style={{ height }} />;
}

export default SpacerBlock;
